import React, { useEffect, useState, useRef } from 'react';
export function Interface() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      });
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <div ref={sectionRef} className="py-32 md:py-40 bg-white transition-colors duration-500" data-id="element-124">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-125">
        <div className="text-center mb-16" data-id="element-126">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-charcoal-500" data-id="element-127">
            As simple as texting a friend
          </h2>
          <p className="text-xl text-charcoal-400 leading-relaxed max-w-2xl mx-auto" data-id="element-128">
            Clean. Fast. Zero clutter. Just the answers you need.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-8" data-id="element-129">
          <div className={`transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-130">
            <div className="relative max-w-xs mx-auto" data-id="element-131">
              <div className="absolute -inset-4 bg-gradient-to-r from-coral-400/20 to-peach-500/10 blur-2xl rounded-3xl" data-id="element-132" />
              <div className="relative rounded-3xl overflow-hidden shadow-2xl" data-id="element-133">
                <img src="https://cdn.magicpatterns.com/uploads/iGxSbxTYJge6G2nvjtUefj/Simulator_Screenshot_-_iPhone_17_-_2025-12-10_at_13.36.16.png" alt="Caltalk dashboard showing calorie tracking and meal planning" className="w-full h-auto" data-id="element-134" />
              </div>
            </div>
          </div>

          <div className={`transition-all duration-1000 delay-200 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-135">
            <div className="relative max-w-xs mx-auto" data-id="element-136">
              <div className="absolute -inset-4 bg-gradient-to-r from-coral-400/20 to-peach-500/10 blur-2xl rounded-3xl" data-id="element-137" />
              <div className="relative rounded-3xl overflow-hidden shadow-2xl" data-id="element-138">
                <img src="https://cdn.magicpatterns.com/uploads/puVFm4q44y8QmPQPBSGzSt/image_121.png" alt="Caltalk chat showing egg options based on remaining calories" className="w-full h-auto" data-id="element-139" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}